@if (appUpdateService.updateAvailable()) {
  <app-update />
}

<router-outlet />
